import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useLocale } from '@react-aria/i18n';
import { useEffect } from 'react';

dayjs.extend(localizedFormat);

const localeImporters = {
  cs: () => import('dayjs/locale/cs'), // Czech Republic
  'de-CH': () => import('dayjs/locale/de-ch'), // Switzerland
  'en-IL': () => import('dayjs/locale/en-il'), // Israel
  'en-GB': () => import('dayjs/locale/en-gb'), // UK
  'en-US': () => import('dayjs/locale/en'), // US
  et: () => import('dayjs/locale/et'), // Estonia
  fr: () => import('dayjs/locale/fr'), // France
  kk: () => import('dayjs/locale/kk'), // Kazakhstan
  lt: () => import('dayjs/locale/lt'), // Lithuania
  lv: () => import('dayjs/locale/lv'), // Latvia
  mt: () => import('dayjs/locale/mt'), // Malta
  pl: () => import('dayjs/locale/pl'), // Poland
  sv: () => import('dayjs/locale/sv'), // Sweden
};

const setDayJsLocale = async (iso2Code: string) => {
  const importLocale = localeImporters[iso2Code as keyof typeof localeImporters];
  if (importLocale) {
    await importLocale();
    dayjs.locale(iso2Code);
  } else {
    await localeImporters['en-GB']();
    dayjs.locale('en-GB');
  }
};

export const useLocalisation = () => {
  const { locale } = useLocale();
  useEffect(() => {
    setDayJsLocale(locale);
  }, [locale]);
};
